import { lazy } from "react";
export { CRM_DOCUMENT_REGISTER_PATH } from "./path";
export const CrmDocumentRegisterPage = lazy(() => import("./page"));
